var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-12 p-0"},[_c('Sidebar')],1),_c('div',{staticClass:"col-lg-9 p-4 bg-base"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }